import { AppRouter } from './router'
import { AuthContextProvider } from '@/context/auth-context'
import { ThemeProvider } from '@/lib/theme-context'
import { TooltipProvider } from '@/components/ui/tooltip'

export function App() {
  return (
    <AuthContextProvider>
      <ThemeProvider>
        <TooltipProvider>
          <AppRouter />
        </TooltipProvider>
      </ThemeProvider>
    </AuthContextProvider>
  )
}
